import { All } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import FinancialReportingDetails from "../components/FinancialReporting/FinancialReportingDetails";

export function mapStateToProps({ appState }: All) {
  return {
    appState: appState.financialReporting,
    currentApp: appState.app,
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateReportPeriod: (reportPeriod: string[]) => {
      dispatch(actions.updateFilter("reportPeriod", reportPeriod));
      dispatch(actions.searchPush());
    },
    updateLatestReportPeriod: (reportPeriod: string) => {
      dispatch(actions.updateUi("latestReportPeriod", reportPeriod));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinancialReportingDetails);
